function clearOptions(state, input, path) {
  let options = state.get(`${input.field}.${path}`)
  if (options) {
    options = options.map(option => {
      return {
        ...option,
        selected: false
      }
    })
    state.set(`${input.field}.${path}`, options)
  }
}

export default function clearValue({ state, input }) {
  clearOptions(state, input, 'filteredOptions')
  clearOptions(state, input, 'options')
  let options = state.get(`${input.field}.options`)
  let data = []
  if (!options) {
    data = ''
  }
  state.set(`${input.field}.value`, data)
}



// WEBPACK FOOTER //
// ./src/modules/client/actions/clearValue.js